import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
    marginBottom: 100,
  },
  header: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.common.black,
    width: "100%",
    paddingBottom: 16,
    borderBottom: "1px solid #e8e8e8",
  },
  paper: {
    padding: 32,
    boxShadow: "none",
  },
  connectorsStatus: {
    margin: "20px 0",
  },
  connectorsActionsButton: {
    marginRight: 5,
  },
}));